let isLogin = true;
let isUat = true;
let isDev = false;
let platform = "mweb";
let language = "";
let country = "";
let currency = "";
let sessionKey = "";
/** sid 不可以未空 */
let sid = "";
/** web 专用 */
let country2 = "";
let countryId = "";

export default class Constant {
	public static set isLogin(login: boolean) {
		isLogin = login;
	}
	public static get isLogin(): boolean {
		return isLogin;
	}

	public static set isUat(uat: boolean) {
		isUat = uat;
	}
	public static get isUat(): boolean {
		return isUat;
	}
	public static set isDev(inDev: boolean) {
		isDev = inDev;
	}
	public static get isDev(): boolean {
		return isDev;
	}
	public static set platform(fromPlatform: string) {
		platform = fromPlatform;
	}
	public static get platform(): string {
		return platform;
	}

	public static set language(cookieLang: string) {
		language = cookieLang;
	}
	public static get language(): string {
		return language;
	}

	public static set country(cookieCountry: string) {
		country = cookieCountry;
	}
	public static get country(): string {
		return country;
	}

	public static set countryCode2(cookieCountry: string) {
		country2 = cookieCountry;
	}
	public static get countryCode2(): string {
		return country2;
	}

	public static set currency(cookieCurrency: string) {
		currency = cookieCurrency;
	}
	public static get currency(): string {
		return currency;
	}

	public static set sessionKey(cookieSessionKey: string) {
		sessionKey = cookieSessionKey;
	}
	public static get sessionKey(): string {
		return sessionKey;
	}

	public static set sid(cookieSid: string) {
		sid = cookieSid;
	}
	public static get sid(): string {
		return sid || null;
	}

	public static set countryId(cookieCountry: string) {
		countryId = cookieCountry;
	}

	public static get countryId(): string {
		return countryId;
	}
}

export const setCookie = function (
	sKey: string,
	sValue: string,
	sPath?: string,
	sDomain?: string,
	vEnd?: number | Date | string,
	bSecure?: boolean
) {
	// console.log(sKey, sValue, vEnd, sPath, sDomain, bSecure);
	if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
		return false;
	}
	let sExpires = "; expires=Mon, 24-Jan-2089 10:25:13 GMT";
	if (vEnd) {
		switch (vEnd.constructor) {
			case Number:
				sExpires =
					vEnd === Infinity
						? "; expires=Fri, 31 Dec 9999 23:59:59 GMT"
						: "; max-age=" + vEnd;
				break;
			case String:
				sExpires = "; expires=" + vEnd;
				break;
			case Date:
				sExpires = "; expires=" + (vEnd as Date).toUTCString();
				break;
			default:
				break;
		}
	}
	document.cookie =
		encodeURIComponent(sKey) +
		"=" +
		encodeURIComponent(sValue) +
		sExpires +
		(sDomain ? "; domain=" + sDomain : "") +
		(sPath ? "; path=" + sPath : "") +
		(bSecure ? "; secure" : "");
	return true;
};

export const delKeyFromCookie = (
	delKey: string,
	sPath: string = "/",
	sDomain: string = WEB_HOST[Constant.isUat ? "UAT" : "Online"].domain
) => {
	const allCookie = document.cookie.split(";");
	if (allCookie.length > 0) {
		const targetCookie = allCookie.find(co =>
			decodeURIComponent(co.trim()).match(new RegExp(`^${delKey}=`, "ig"))
		);
		if (targetCookie) {
			const exp = new Date();
			exp.setTime(exp.getTime() - 60 * 1000);
			document.cookie =
				targetCookie +
				";expires=" +
				exp.toUTCString() +
				(sDomain ? "; domain=" + sDomain : "") +
				(sPath ? "; path=" + sPath : "");
		}
	}
};

/** 2022.01 兰亭主站新增字段 local = 语言+国家二位码+货币 */
export const comCookieLocal = (localKeys: string[] = []) => {
	return encodeURIComponent(localKeys.join("|"));
};

// host
export const Host = {
	true: {
		mHost: "http://mqa.ouku.com",
		gmHost: "http://mqa.ouku.com",
		domain: ".ezbuy.dev"
	},
	false: {
		mHost: "https://m.ouku.com",
		gmHost: "https://m.ouku.com",
		domain: ".ouku.com"
	}
};

export const WEB_HOST = {
	UAT: {
		host: "http://192.168.161.34",
		ghost: "http://192.168.161.34",
		domain: "-ouku.ezbuy.dev"
	},
	Online: {
		host: "https://www.ouku.com",
		ghost: "https://www.ouku.com",
		domain: ".ouku.com"
	}
};

// Web端 国家/地区旗帜 雪碧定位
export const WebCountryFlagPosition = {
	af: "0 0",
	al: "-60px 0",
	dz: "-100px 0",
	as: "-120px 0",
	ad: "-140px 0",
	ao: "-160px 0",
	ai: "-180px 0",
	ag: "-220px 0",
	ar: "-260px 0",
	am: "-280px 0",
	aw: "-300px 0",
	au: "-340px 0",
	at: "-360px 0",
	az: "-380px 0",
	bs: "-400px 0",
	bh: "-420px 0",
	bd: "-440px 0",
	bb: "-460px 0",
	by: "0 -20px",
	be: "-20px -20px",
	bz: "-40px -20px",
	bj: "-60px -20px",
	bm: "-80px -20px",
	bt: "-100px -20px",
	bo: "-120px -20px",
	ba: "-140px -20px",
	bw: "-160px -20px",
	br: "-200px -20px",
	io: "-220px -20px",
	bn: "-240px -20px",
	bg: "-260px -20px",
	bf: "-280px -20px",
	bi: "-300px -20px",
	kh: "-320px -20px",
	cm: "-340px -20px",
	ca: "-360px -20px",
	cv: "-380px -20px",
	ky: "-440px -20px",
	cf: "-460px -20px",
	td: "-480px -20px",
	cl: "0 -40px",
	cn: "-20px -40px",
	cx: "-40px -40px",
	cc: "-80px -40px",
	co: "-100px -40px",
	km: "-140px -40px",
	cg: "-160px -40px",
	ck: "-200px -40px",
	cr: "-220px -40px",
	ci: "-240px -40px",
	hr: "-260px -40px",
	cu: "-280px -40px",
	cy: "-320px -40px",
	cz: "-340px -40px",
	dk: "-360px -40px",
	dj: "-380px -40px",
	dm: "-400px -40px",
	do: "-420px -40px",
	ec: "-440px -40px",
	eg: "-460px -40px",
	sv: "-480px -40px",
	gq: "-20px -60px",
	er: "-40px -60px",
	ee: "-60px -60px",
	et: "-80px -60px",
	eu: "-100px -60px",
	fk: "-120px -60px",
	fj: "-180px -60px",
	fi: "-200px -60px",
	fr: "-220px -60px",
	tf: "-240px -60px",
	gf: "-260px -60px",
	ga: "-280px -60px",
	gm: "-320px -60px",
	ge: "-340px -60px",
	de: "-360px -60px",
	gh: "-380px -60px",
	gi: "-400px -60px",
	gr: "-420px -60px",
	gl: "-440px -60px",
	gd: "-460px -60px",
	gt: "0 -80px",
	gu: "-20px -80px",
	gg: "-40px -80px",
	gn: "-60px -80px",
	gw: "-80px -80px",
	gy: "-100px -80px",
	ht: "-120px -80px",
	hn: "-160px -80px",
	hk: "-180px -80px",
	hu: "-200px -80px",
	is: "-240px -80px",
	in: "-280px -80px",
	id: "-300px -80px",
	ir: "-320px -80px",
	iq: "-340px -80px",
	ie: "-360px -80px",
	il: "-420px -80px",
	it: "-440px -80px",
	jm: "-460px -80px",
	jp: "-480px -80px",
	je: "0 -100px",
	jo: "-20px -100px",
	kz: "-40px -100px",
	ke: "-60px -100px",
	ki: "-80px -100px",
	kw: "-120px -100px",
	kg: "-140px -100px",
	lv: "-180px -100px",
	lb: "-200px -100px",
	ls: "-220px -100px",
	lr: "-240px -100px",
	li: "-280px -100px",
	lt: "-300px -100px",
	lu: "-320px -100px",
	mk: "-360px -100px",
	mg: "-380px -100px",
	mw: "-400px -100px",
	my: "-420px -100px",
	mv: "-440px -100px",
	ml: "-460px -100px",
	mt: "-480px -100px",
	mh: "0 -120px",
	mq: "-20px -120px",
	mr: "-40px -120px",
	mu: "-60px -120px",
	yt: "-80px -120px",
	mx: "-100px -120px",
	fm: "-120px -120px",
	md: "-140px -120px",
	mc: "-160px -120px",
	mn: "-180px -120px",
	me: "-200px -120px",
	ms: "-220px -120px",
	ma: "-240px -120px",
	mz: "-260px -120px",
	mm: "-280px -120px",
	na: "-300px -120px",
	nr: "-340px -120px",
	np: "-360px -120px",
	an: "-380px -120px",
	nl: "-400px -120px",
	nz: "-440px -120px",
	ni: "-460px -120px",
	ne: "-480px -120px",
	ng: "0 -140px",
	nu: "-20px -140px",
	nf: "-40px -140px",
	mp: "-120px -140px",
	no: "-140px -140px",
	om: "-220px -140px",
	pk: "-260px -140px",
	pw: "-280px -140px",
	pa: "-320px -140px",
	pg: "-340px -140px",
	py: "-360px -140px",
	pe: "-380px -140px",
	ph: "-400px -140px",
	pn: "-420px -140px",
	pl: "-440px -140px",
	pt: "-460px -140px",
	pr: "-480px -140px",
	qa: "0 -160px",
	ro: "-60px -160px",
	ru: "-80px -160px",
	rw: "-100px -160px",
	lc: "-160px -160px",
	ws: "-220px -160px",
	sm: "-240px -160px",
	st: "-260px -160px",
	sa: "-280px -160px",
	sn: "-320px -160px",
	rs: "-340px -160px",
	sc: "-360px -160px",
	sl: "-380px -160px",
	sg: "-400px -160px",
	sk: "-440px -160px",
	si: "-460px -160px",
	sb: "-480px -160px",
	so: "0 -180px",
	xs: "-20px -180px",
	za: "-40px -180px",
	kp: "-80px -180px",
	es: "-120px -180px",
	lk: "-140px -180px",
	kn: "-160px -180px",
	vc: "-180px -180px",
	sd: "-200px -180px",
	sr: "-220px -180px",
	sj: "-240px -180px",
	sz: "-260px -180px",
	se: "-280px -180px",
	ch: "-300px -180px",
	sy: "-320px -180px",
	tw: "-360px -180px",
	tj: "-380px -180px",
	tz: "-400px -180px",
	th: "-420px -180px",
	tg: "-460px -180px",
	tk: "-480px -180px",
	to: "0px -200px",
	tt: "-20px -200px",
	tn: "-60px -200px",
	tr: "-80px -200px",
	tm: "-100px -200px",
	tc: "-120px -200px",
	tv: "-140px -200px",
	ug: "-160px -200px",
	ua: "-180px -200px",
	ae: "-240px -200px",
	gb: "-260px -200px",
	us: "-320px -200px",
	uy: "-340px -200px",
	uz: "-360px -200px",
	vu: "-380px -200px",
	va: "-400px -200px",
	ve: "-420px -200px",
	vn: "-440px -200px",
	vg: "-460px -200px",
	vi: "-480px -200px",
	eh: "-40px -220px",
	ye: "-100px -220px",
	zm: "-120px -220px",
	zw: "-140px -220px",
	tp: "-160px -220px",
	fo: "-180px -220px",
	gp: "-200px -220px",
	kr: "-220px -220px",
	la: "-240px -220px",
	ly: "-260px -220px",
	mo: "-280px -220px",
	ic: "-320px -220px",
	cd: "-340px -220px",
	xy: "-360px -220px",
	pf: "-380px -220px",
	sh: "-400px -220px",
	re: "-220px -60px",
	pm: "-220px -60px",
	wf: "-220px -60px",
	nc: "-220px -60px"
};
// M端国家国旗雪碧图定位配置数据
export const CountryIConPosition = {
	"-AF": "-10px -46px",
	AD: "-10px -10px",
	AE: "-54px -10px",
	AL: "-98px -46px",
	AM: "-10px -82px",
	AN: "-54px -82px",
	AO: "-98px -82px",
	AR: "-142px -10px",
	AS: "-142px -46px",
	AT: "-142px -82px",
	AU: "-10px -118px",
	AW: "-54px -118px",
	AZ: "-98px -118px",
	BA: "-142px -118px",
	BB: "-186px -10px",
	BD: "-186px -46px",
	BE: "-186px -82px",
	BF: "-186px -118px",
	BG: "-10px -154px",
	"BG-AG": "-54px -46px",
	"BG-AI": "-98px -10px",
	BH: "-54px -154px",
	BI: "-98px -154px",
	BJ: "-142px -154px",
	BM: "-186px -154px",
	BN: "-10px -190px",
	BO: "-54px -190px",
	BR: "-98px -190px",
	BS: "-142px -190px",
	BT: "-186px -190px",
	BW: "-230px -10px",
	BY: "-230px -46px",
	BZ: "-230px -82px",
	CA: "-230px -118px",
	CC: "-230px -154px",
	CD: "-230px -190px",
	CF: "-10px -226px",
	CG: "-54px -226px",
	CH: "-98px -226px",
	CI: "-186px -226px",
	CK: "-142px -226px",
	CL: "-230px -226px",
	CM: "-274px -10px",
	CN: "-274px -46px",
	CO: "-274px -82px",
	CR: "-274px -118px",
	CU: "-274px -154px",
	CV: "-274px -190px",
	CX: "-274px -226px",
	CY: "-10px -262px",
	CZ: "-54px -262px",
	DE: "-98px -262px",
	DJ: "-142px -262px",
	DK: "-186px -262px",
	DM: "-274px -262px",
	DO: "-230px -262px",
	DZ: "-318px -10px",
	EC: "-318px -46px",
	EE: "-318px -82px",
	EG: "-318px -118px",
	EH: "-318px -154px",
	ER: "-318px -190px",
	ES: "-318px -226px",
	ET: "-318px -262px",
	FI: "-10px -298px",
	FJ: "-54px -298px",
	FK: "-98px -298px",
	FM: "-142px -298px",
	FO: "-186px -298px",
	FR: "-230px -298px",
	GA: "-274px -298px",
	GB: "-318px -298px",
	GD: "-362px -10px",
	GE: "-362px -46px",
	GF: "-362px -82px",
	GG: "-362px -118px",
	GH: "-362px -154px",
	GI: "-362px -190px",
	GL: "-362px -226px",
	GM: "-362px -262px",
	GN: "-362px -298px",
	GP: "-10px -334px",
	GQ: "-98px -334px",
	GR: "-54px -334px",
	GT: "-142px -334px",
	GU: "-186px -334px",
	GW: "-230px -334px",
	GY: "-274px -334px",
	HK: "-10px -370px",
	HN: "-318px -334px",
	HR: "-54px -370px",
	HT: "-362px -334px",
	HU: "-98px -370px",
	IC: "-142px -370px",
	ID: "-186px -370px",
	IE: "-230px -370px",
	IL: "-274px -370px",
	IN: "-318px -370px",
	IO: "-362px -370px",
	IQ: "-406px -10px",
	IR: "-406px -46px",
	IS: "-406px -82px",
	IT: "-406px -118px",
	JE: "-406px -154px",
	JM: "-406px -190px",
	JO: "-406px -226px",
	JP: "-406px -262px",
	KE: "-406px -298px",
	KG: "-406px -334px",
	KH: "-406px -370px",
	KI: "-10px -406px",
	KM: "-54px -406px",
	KN: "-98px -406px",
	KP: "-142px -406px",
	KR: "-186px -406px",
	KW: "-230px -406px",
	KY: "-274px -406px",
	KZ: "-318px -406px",
	LA: "-362px -406px",
	LB: "-406px -406px",
	LC: "-450px -10px",
	LI: "-450px -46px",
	LK: "-450px -82px",
	LR: "-450px -118px",
	LS: "-450px -154px",
	LT: "-450px -190px",
	LU: "-450px -226px",
	LV: "-450px -262px",
	LY: "-450px -298px",
	MA: "-450px -334px",
	MC: "-450px -370px",
	MD: "-450px -406px",
	ME: "-10px -442px",
	MG: "-54px -442px",
	MH: "-98px -442px",
	MK: "-142px -442px",
	ML: "-186px -442px",
	MM: "-230px -442px",
	MN: "-274px -442px",
	MO: "-318px -442px",
	MP: "-362px -442px",
	MQ: "-406px -442px",
	MR: "-450px -442px",
	MS: "-494px -10px",
	MT: "-494px -46px",
	MU: "-494px -82px",
	MV: "-494px -118px",
	MW: "-494px -154px",
	MX: "-494px -190px",
	MY: "-494px -226px",
	MZ: "-494px -262px",
	NA: "-494px -298px",
	NC: "-494px -334px",
	NE: "-494px -370px",
	NF: "-494px -406px",
	NG: "-494px -442px",
	NI: "-10px -478px",
	NL: "-54px -478px",
	NO: "-98px -478px",
	NP: "-142px -478px",
	NR: "-186px -478px",
	NU: "-230px -478px",
	NZ: "-274px -478px",
	OM: "-318px -478px",
	PA: "-362px -478px",
	PE: "-406px -478px",
	PF: "-450px -478px",
	PG: "-494px -478px",
	PH: "-538px -10px",
	PK: "-538px -46px",
	PL: "-538px -82px",
	PM: "-538px -118px",
	PN: "-538px -154px",
	PR: "-538px -190px",
	PT: "-538px -226px",
	PW: "-538px -262px",
	PY: "-538px -298px",
	QA: "-538px -334px",
	RE: "-538px -370px",
	RO: "-538px -406px",
	RS: "-538px -442px",
	RU: "-538px -478px",
	RW: "-10px -514px",
	SA: "-54px -514px",
	SB: "-98px -514px",
	SC: "-142px -514px",
	SD: "-186px -514px",
	SE: "-230px -514px",
	SG: "-274px -514px",
	SH: "-318px -514px",
	SI: "-362px -514px",
	SJ: "-406px -514px",
	SK: "-450px -514px",
	SL: "-494px -514px",
	SM: "-538px -514px",
	SN: "-582px -10px",
	SO: "-582px -46px",
	SR: "-582px -82px",
	ST: "-582px -118px",
	SV: "-582px -154px",
	SY: "-582px -190px",
	SZ: "-582px -226px",
	TC: "-582px -262px",
	TD: "-582px -298px",
	TF: "-582px -334px",
	TG: "-582px -370px",
	TH: "-582px -406px",
	TJ: "-582px -442px",
	TK: "-582px -478px",
	TM: "-582px -514px",
	TN: "-10px -550px",
	TO: "-54px -550px",
	TP: "-98px -550px",
	TR: "-142px -550px",
	TT: "-186px -550px",
	TV: "-230px -550px",
	TW: "-274px -550px",
	TZ: "-318px -550px",
	UA: "-362px -550px",
	UG: "-406px -550px",
	US: "-450px -550px",
	UY: "-494px -550px",
	UZ: "-538px -550px",
	VA: "-582px -550px",
	VC: "-10px -586px",
	VE: "-54px -586px",
	VG: "-98px -586px",
	VI: "-142px -586px",
	VN: "-186px -586px",
	VU: "-230px -586px",
	WF: "-274px -586px",
	WS: "-318px -586px",
	XS: "-362px -586px",
	XY: "-406px -586px",
	YE: "-450px -586px",
	YT: "-494px -586px",
	ZA: "-538px -586px",
	ZM: "-582px -586px",
	ZW: "-626px -10px"
};
